
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Tempotravelleronrentforcorporate() {



    const cardData =
    {
        keyword: 'Tempo Traveller on Rent for Corporate Pune',
        heading: 'etravo : Tempo Traveller on Rent for Corporate Pune',
        headingDescription: 'eTravo offers Tempo Traveller on Rent for Corporate Pune, providing a smart and flexible travel solution for small corporate groups, executive teams, and client visits. Our Tempo Travellers are equipped with air conditioning, pushback seats, ample legroom, and luggage space to ensure a smooth and comfortable ride. Ideal for daily commutes, business tours, airport transfers, and off-site meetings, our vehicles come with experienced chauffeurs and real-time GPS tracking. Whether you are planning in-city travel or outstation business trips, eTravo guarantees punctual, safe, and cost-effective corporate transport in Pune.',

        top: 'Top Places to Visit in Pune with etravo',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a majestic 18th-century fortification located in the heart of Pune. Built in 1732 by the Peshwas of the Maratha Empire, it served as their seat of power until 1818. The grand entrance, known as the Delhi Darwaza, and the intricate architecture reflect the glory of Maratha rule. Although much of the fort was destroyed in a fire in 1828, its remaining walls, gardens, and fountains still echo the stories of royal intrigue, valor, and politics. It is a must-visit for history enthusiasts and those curious about Pune’s regal heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace is not just a stunning piece of architecture but also a monument of national significance. Built in 1892 by Sultan Aga Khan III, the palace is closely associated with India’s freedom movement. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. With its Italian arches, sprawling gardens, and a museum housing Gandhiji’s memorabilia, the palace provides a serene yet powerful reminder of India’s struggle for independence. It’s a place of reflection, peace, and inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, meaning 'Lion's Fort', is perched atop a rugged hill about 35 km from Pune. A site of many historical battles, it is most famous for the Battle of Sinhagad in 1670, where the Maratha warrior Tanaji Malusare fought valiantly. The fort offers panoramic views of the surrounding Sahyadri mountains and the Khadakwasla dam. A favorite among trekkers and nature lovers, the fort also features remnants of ancient gates, temples, military stables, and even food stalls offering local snacks like kanda bhaji and pithla-bhakri."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple is a hidden gem amidst Pune’s urban sprawl. Carved out of a single basalt rock in the 8th century, this ancient temple is dedicated to Lord Shiva and features beautifully sculpted pillars and a Nandi bull in the courtyard. Despite being in the middle of the bustling Jangli Maharaj Road, the temple offers a peaceful, almost timeless ambiance. Its unfinished structure adds to its mystique, making it a fascinating stop for lovers of history, architecture, and spirituality."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum is a treasure trove of India's rich cultural legacy. Founded by Dr. Dinkar G. Kelkar in memory of his son, the museum houses over 20,000 artifacts that span centuries. From musical instruments and antique furniture to intricate ivory carvings and everyday tools, each item tells a story of India’s diverse traditions and artistry. A full-scale replica of a traditional Maratha wada (mansion) is one of the highlights. Located in central Pune, this museum offers a deep dive into India’s folk and decorative arts."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "One of Pune’s most beloved and iconic spiritual sites, the Dagdusheth Halwai Ganapati Temple attracts thousands of devotees every day. The temple is known for its magnificent Ganesh idol, adorned with gold and fresh flowers, and its vibrant atmosphere during Ganesh Chaturthi. Built over 130 years ago by a sweet merchant named Dagdusheth Halwai, the temple is not only a center of faith but also a hub for community activities, charity, and cultural events. Its grandeur and spiritual aura make it a must-visit."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in the serene Koregaon Park area, the Osho Ashram is a global meditation hub that attracts spiritual seekers from across the world. Founded by the Indian mystic Osho, the resort offers a range of meditation techniques, wellness therapies, and personal growth workshops amidst tranquil Zen-like gardens and modern infrastructure. Visitors can enroll for day passes or longer retreats and enjoy a unique blend of spirituality, luxury, and self-discovery in one of India’s most sophisticated wellness centers."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Inspired by the Korakuen Garden of Okayama, Japan, this beautifully landscaped park, also known as the Pu La Deshpande Udyan, is a symbol of Indo-Japanese friendship. Spread across 10 acres, it features manicured lawns, flowing streams, wooden bridges, and bonsai-style trees. The garden offers a peaceful environment for walking, photography, or quiet contemplation, making it one of the most scenic urban escapes in Pune."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of the oldest heritage landmarks in Pune, rising 2,100 feet above sea level. A climb of 103 steps leads you to a group of five temples, the main one dedicated to Goddess Parvati. From the top, visitors are treated to a panoramic view of the entire city. The hill also houses a small museum and the Peshwa-era samadhis (memorials), making it a spiritual and historical site worth visiting—especially during sunrise or sunset."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Situated about 20 km from Pune, Khadakwasla Dam is a peaceful retreat that provides drinking water to the city. Surrounded by hills and greenery, it’s a favorite weekend getaway for picnics, morning walks, and watching the sunset over the backwaters. The area is also popular with cyclists and joggers. On weekends, local food stalls set up shop, offering mouthwatering Maharashtrian snacks, making it a blend of natural beauty and local flavor."
  }
],

"services": [
  {
    "name": "Corporate Tempo Traveller Pune",
    "description": "eTravo offers corporate Tempo Traveller services in Pune, ideal for small group travel with comfort and convenience. Our vehicles are perfect for office commutes, client meetings, and intercity business trips, ensuring a smooth and professional ride."
  },
  {
    "name": "AC Tempo Traveller for Office Commute Pune",
    "description": "Travel comfortably with eTravo’s AC Tempo Traveller services for office commute in Pune. Equipped with air-conditioning and spacious seating, these vehicles provide a reliable and pleasant daily transportation option for corporate staff."
  },
  {
    "name": "Staff Shuttle Tempo Traveller Pune",
    "description": "eTravo’s staff shuttle Tempo Traveller services in Pune are designed to facilitate efficient employee transport. Our scheduled shuttle services offer punctual pickups, clean vehicles, and professional drivers, making daily commutes hassle-free."
  },
  {
    "name": "Small Group Corporate Travel Pune",
    "description": "For small group corporate travel in Pune, eTravo provides Tempo Travellers that combine comfort, safety, and flexibility. Whether it’s a business meeting or site visit, our vehicles accommodate your team’s travel needs efficiently."
  },
  {
    "name": "Tempo Traveller for Business Meetings Pune",
    "description": "eTravo’s Tempo Travellers are ideal for business meetings in Pune, offering timely and comfortable transport for executives and teams. With ample space and climate control, these vehicles ensure you arrive fresh and on schedule."
  },
  {
    "name": "Comfortable Office Commute Pune",
    "description": "Enhance your office commute with eTravo’s comfortable Tempo Traveller services in Pune. Perfect for mid-sized groups, our vehicles offer air-conditioning, spacious interiors, and reliable service to keep your workforce productive and relaxed."
  }
],
"tableData": [
  ["Corporate Tempo Traveller Pune", "AC Tempo Traveller for Office Commute Pune"],
  ["Staff Shuttle Tempo Traveller Pune", "Small Group Corporate Travel Pune"],
  ["Tempo Traveller for Business Meetings Pune", "Comfortable Office Commute Pune"]
],




"whychoose": [
    {
        "WhyChooseheading": "Tempo Traveller Rental for Corporate Travel in Pune",
        "WhyChoosedescription": "eTravo offers reliable Tempo Traveller rentals ideal for corporate travel in Pune. Perfect for small groups, client pickups, and inter-office transfers, our vehicles ensure comfortable and efficient transportation tailored for business needs."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Tempo Travellers",
        "WhyChoosedescription": "Our Tempo Travellers come equipped with air-conditioning, comfortable seating, ample legroom, charging ports, and clean interiors—providing a smooth and pleasant ride for corporate travelers."
    },
    {
        "WhyChooseheading": "Perfect for Small Corporate Groups and Teams",
        "WhyChoosedescription": "Whether it’s transporting a team to meetings, airport transfers, or corporate outings, our Tempo Travellers accommodate groups of 9 to 12 passengers, making them ideal for efficient group travel."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Corporate Etiquette",
        "WhyChoosedescription": "Our professional chauffeurs are trained to provide courteous and timely service, with excellent knowledge of Pune’s business hubs like Hinjewadi, Magarpatta, and Kharadi to ensure smooth travel."
    },
    {
        "WhyChooseheading": "On-Time Service with Real-Time Tracking",
        "WhyChoosedescription": "With GPS-enabled vehicles and real-time tracking, clients receive timely updates and alerts to ensure punctual pickups and drop-offs aligned with your corporate schedules."
    },
    {
        "WhyChooseheading": "Transparent Pricing and GST-Compliant Invoices",
        "WhyChoosedescription": "We offer clear, upfront pricing without hidden fees and provide GST-compliant invoices to simplify your company’s billing and reimbursement processes."
    },
    {
        "WhyChooseheading": "24/7 Availability for Corporate Travel Needs",
        "WhyChoosedescription": "Our Tempo Traveller rental services are available round-the-clock, accommodating early meetings, late returns, and urgent travel requirements for your business."
    },
    {
        "WhyChooseheading": "Easy Booking via App, Website, or Phone",
        "WhyChoosedescription": "Booking a Tempo Traveller with eTravo is fast and convenient through our app, website, or customer support, with instant confirmation and driver details for a hassle-free experience."
    }
]


































    }

const faqData = [
    [
        {
            question: 'Does eTravo provide Tempo Travellers on rent for corporate use in Pune?',
            answer: 'Yes, eTravo offers Tempo Travellers on rent in Pune, ideal for corporate transportation including employee commutes, airport transfers, and business outings.',
        },
        {
            question: 'What is the seating capacity of Tempo Travellers available for rent?',
            answer: 'Our Tempo Travellers typically seat between 9 to 12 passengers, providing spacious and comfortable travel for small corporate groups.',
        },
        {
            question: 'Are Tempo Travellers suitable for long-distance corporate travel from Pune?',
            answer: 'Absolutely. They are perfect for both local commutes within Pune and outstation business trips to nearby cities such as Mumbai, Lonavala, and Nashik.',
        },
        {
            question: 'What amenities do eTravo’s Tempo Travellers include?',
            answer: 'Our Tempo Travellers come equipped with air-conditioning, comfortable seating, ample luggage space, and experienced chauffeurs to ensure a smooth ride.',
        },
        {
            question: 'Can Tempo Travellers be booked for corporate events or client visits?',
            answer: 'Yes, many corporate clients use Tempo Travellers for client pickups, site visits, and event transportation to ensure timely and professional service.',
        },
        {
            question: 'Is real-time vehicle tracking available for Tempo Traveller bookings?',
            answer: 'Yes, all our vehicles, including Tempo Travellers, are GPS-enabled, allowing corporate clients to track their rides in real time for added security and convenience.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Rajesh Patil',
        designation: 'Operations Manager, TechNova Pvt. Ltd.',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s Tempo Traveller service has been a reliable choice for our corporate team travels in Pune. Comfortable vehicles and professional drivers every time.”',
    },
    {
        name: 'Ms. Snehal Kulkarni',
        designation: 'HR Executive, InfoTech Solutions',
        rating: [1, 1, 1, 1, 1],
        text: '“We frequently use eTravo’s Tempo Travellers for client visits and employee transfers. The service is punctual, clean, and hassle-free.”',
    },
];























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller on Rent for Corporate Pune",
  "image": [
    "https://www.etravo.in/images/keyword/tempo-traveller-corporate-pune.jpg"
  ],
  "description": "Book tempo traveller on rent for corporate needs in Pune with eTravo. Ideal for employee transportation, business travel, and corporate events. Comfortable AC vehicles with trained drivers for hassle-free service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "sku": "tempo-traveller-corporate-pune",
  "url": "https://www.etravo.in/tempo-traveller-on-rent-for-corporate-pune",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.6",
    "reviewCount": "1987",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2899",
    "priceValidUntil": "2026-12-31",
    "itemCondition": "https://schema.org/NewCondition",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/tempo-traveller-on-rent-for-corporate-pune"
  }
};

 

// const productSchema = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Tempo Traveller on Rent for Corporate Pune",
//   "image": "https://www.etravo.in/images/keyword/tempo-traveller-corporate-pune.jpg",
//   "description": "Book tempo traveller on rent for corporate needs in Pune with eTravo. Ideal for employee transportation, business travel, and corporate events. Comfortable AC vehicles with trained drivers for hassle-free service.",
//   "brand": {
//     "@type": "Brand",
//     "name": "eTravo"
//   },
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.6",
//     "ratingCount": "1987"
//   },
//   "offers": {
//     "@type": "Offer",
//     "priceCurrency": "INR",
//     "price": "2899",
//     "availability": "https://schema.org/InStock",
//     "url": "https://www.etravo.in/tempo-traveller-on-rent-for-corporate-pune"
//   }
// };





    return (
        <div>

   <Helmet>
      <title>Tempo Traveller on Rent for Corporate Pune | eTravo</title>
      <meta
        name="description"
        content="Hire tempo traveller on rent for corporate transport in Pune with eTravo. Perfect for employee shuttles, corporate travel, and business commutes. Reliable and cost-effective services with AC tempo travellers."
      />
      <script type="application/ld+json">
        {JSON.stringify(productSchema)}
      </script>
    </Helmet>
{/* <Helmet>
  <title>Tempo Traveller on Rent for Corporate Pune | eTravo</title>
  <meta
    name="description"
    content="Hire tempo traveller on rent for corporate transport in Pune with eTravo. Perfect for employee shuttles, corporate travel, and business commutes. Reliable and cost-effective services with AC tempo travellers."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet> */}



            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/34.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Tempotravelleronrentforcorporate;